import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Radio, { RadioOption } from '@components/radio/Radio'

const TEST_DATA = [
  { label: 'Item 1', value: 1 },
  { label: 'Item 2', value: 2 },
  { label: 'Item 3', value: 3 },
]

const RadiosSection = () => {
  const [value, setValue] = React.useState<RadioOption>()

  const customRenderItem = (item: { label: string; value: any }) => (
    <DummyCard>
      <DummyText>Custom render function</DummyText>
      <DummyText>{item.label}</DummyText>
    </DummyCard>
  )

  return (
    <Section>
      <SectionTitle>Radios</SectionTitle>
      <Container>
        <Radio data={TEST_DATA} value={value} onItemSelected={(itm) => setValue(itm)} />
      </Container>
      <Container>
        <Radio disabled data={TEST_DATA} value={value} onItemSelected={(itm) => setValue(itm)} />
      </Container>
      <Container>
        <Radio withoutSeparators data={TEST_DATA} value={value} onItemSelected={(itm) => setValue(itm)} />
      </Container>
      <Container>
        <Radio iconOnTheRight data={TEST_DATA} value={value} onItemSelected={(itm) => setValue(itm)} />
      </Container>
      <Container>
        <Radio
          withoutSeparators
          data={TEST_DATA.map((item) => ({ ...item, renderItem: () => customRenderItem(item) }))}
          value={value}
          onItemSelected={(item) => setValue(item)}
        />
      </Container>
      <Container>
        <Radio
          disabled
          withoutSeparators
          data={TEST_DATA.map((item) => ({ ...item, renderItem: () => customRenderItem(item) }))}
          value={value}
          onItemSelected={(item) => setValue(item)}
        />
      </Container>
    </Section>
  )
}

export default RadiosSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 12px;
`
const DummyCard = styled(View)`
  flex: 1;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 8px;
  height: 100px;
  margin-left: 24px;
  padding: 24px;
  justify-content: center;
  ${(props) => props.theme.constants.shadow};
`
const DummyText = styled(Text)`
  ${(props) => props.theme.fonts.Body};
`
